import type { RouteLocationNormalized } from "vue-router"

/**
 * Préfixes de chemins accessibles sans redirection vers /subscription-cancelled
 * lorsque l'abonnement Homeys est entièrement annulé (aligné sur legacy middleware/status.js).
 */
const ALLOWED_PATH_PREFIXES = [
    "/login",
    "/inscription",
    "/maintenance",
    "/change-space",
    "/subscription-cancelled",
    "/demande/signature-consentement/",
    "/demande/changement-titulaire/",
    "/demande/signature-multi-compteurs/",
    "/demande/prolongement-consentement/",
    "/demande/partage-consentement/",
] as const

/** Routes utilisateur validation / changement mot de passe (hors layout classique). */
const ALLOWED_USER_PATH_REGEX =
    /^\/user\/[^/]+\/(validation|changepassword)(\?|$)/

/**
 * Indique si la navigation est autorisée pour un client Homeys dont tous les abonnements Stripe sont annulés.
 */
export function isRouteAllowedWhenSubscriptionCancelled(
    to: RouteLocationNormalized
): boolean {
    const path = (to.path || "").toLowerCase()
    if (ALLOWED_PATH_PREFIXES.some((p) => path.startsWith(p))) {
        return true
    }
    return ALLOWED_USER_PATH_REGEX.test(path)
}
